import { APIPath } from 'utility/constant'
import { CRUDService } from './crud'
import { CommonUtility } from 'utility/common'
import { BaseService } from './base'

class Competition extends CRUDService {
  constructor() {
    super(APIPath.competitions) // Initialize CRUDService with competitions API path
  }

  get(params) {
    const url = `${APIPath.adminCompetitions}?${CommonUtility.objectToParams(
      params,
    )}`
    return BaseService.get(url)
  }

  getRounds(id) {
    const url = `${APIPath.competitions}/${id}/rounds`
    return BaseService.get(url)
  }

  getCompetitionParticipants(id) {
    const url = `${APIPath.competitions}/${id}/participants`
    return BaseService.get(url)
  }

  getSelectWinners(id, round, filter) {
    const url = `${APIPath.competitions}/${id}/rounds/${round}/winner-selection?${CommonUtility.objectToParams(filter)}`
    return BaseService.get(url)
  }

  getWinners(id, round, filter) {
    const url = `${APIPath.competitions}/${id}/rounds/${round}/winners?${CommonUtility.objectToParams(filter)}`
    return BaseService.get(url)
  }

  moveWinner(id, round, data) {
    const url = `${APIPath.competitions}/${id}/rounds/${round}/select-winners`
    return BaseService.post(url, data)
  }

  getLeaderboardList(id, roundNumber,filter) {
    const url = `${APIPath.competitions}/${id}/leaderboard?roundNumber=${roundNumber}&${CommonUtility.objectToParams(
      filter,
    )}`
    return BaseService.get(url)
  }

  getRoundById(id, roundNumber) {
    const url = `${APIPath.competitions}/${id}/rounds/${roundNumber}`
    return BaseService.get(url)
  }

  getVideoByRound(id, roundNumber, filter) {
    const url = `${APIPath.videos}/uploaded/${id}/rounds/${roundNumber}?${CommonUtility.objectToParams(
      filter,
    )}`
    return BaseService.get(url)
  }

  getCompetitionsByUserId(id) {
    const url = `${APIPath.competitions}/creator/${id}`
    return BaseService.get(url)
  }

  getDashBoardLiveRound() {
    const url = `${APIPath.dashBoardLiveRound}`
    return BaseService.get(url)
  }
}

// Initialize the service with the desired API path
const CompetitionService = new Competition(APIPath.competitions)
Object.freeze(CompetitionService)

export { CompetitionService }
